import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, DrawerStepper } from '@mercai/clever'

import { QUERIES_ADMIN, useUpdateProfile } from '@/services'

import { FormData as LegalRepresentativeFormData } from '../form-legal-representative/form-legal-representative.type'
import { LegalRepresentativeDrawerProps } from './legal-representative-drawer.type'
import { onErrorMessage, onSuccessMessage } from '@/helpers'
import FormLegalRepresentative from '../form-legal-representative/form-legal-representative'
import { useQueryClient } from '@tanstack/react-query'

export const LegalRepresentativeDrawer = ({
  isOpen,
  profile,
  onHandleOpen,
}: LegalRepresentativeDrawerProps) => {
  const { t } = useTranslation('screenProfileShow')

  const queryClient = useQueryClient()

  const [legalRepresentativeData, setLegalRepresentativeData] =
    useState<LegalRepresentativeFormData>({
      name: '',
      email: '',
      phone: '',
      addToAccount: false,
      idDocument: '',
      powerOfAttorney: '',
    })

  const { mutateAsync } = useUpdateProfile()

  const onSubmitLegalRepresentative = async () => {
    const result = await mutateAsync({
      uuid: profile?.uuid || '',
      legalRepresentative: {
        ...legalRepresentativeData,
      },
    })

    if (result.success) {
      onSuccessMessage(
        t('profileFormSuccessUpdateTitle'),
        t('profileFormSuccessUpdateMessage'),
      )

      queryClient.invalidateQueries({
        queryKey: [QUERIES_ADMIN.PROFILE.module, profile?.uuid || ''],
      })

      onHandleOpen()
    } else {
      onErrorMessage(
        t('profileFormErrorUpdateTitle'),
        t('profileFormErrorUpdateMessage'),
      )
    }
  }

  return (
    <DrawerStepper
      translations={{
        optional: '',
      }}
      isOpen={isOpen}
      onHandleOpen={onHandleOpen}
      title={t('legalRepresentativeDrawerTitle')}
      initialStep="root"
      steps={{
        root: {
          isOptional: true,
          backNavigate: 'root',
          component: (
            <FormLegalRepresentative
              profile={profile}
              data={legalRepresentativeData}
              onChange={setLegalRepresentativeData}
            />
          ),
          footer: () => (
            <>
              <Button variant="secondary" onClick={onHandleOpen}>
                {t('profileFormNavigateButtonBack')}
              </Button>
              <Button onClick={() => onSubmitLegalRepresentative()}>
                {t('profileFormNavigateButtonFinish')}
              </Button>
            </>
          ),
        },
      }}
    />
  )
}
